module.exports = __webpack_public_path__ + "static/media/google.dbfbd7a5.png";